export const SPONTANEOUS_VIDEO_MINUTES = 60;

export function isWherebyUiEnabled(enabled: boolean | null | undefined): boolean {
  return enabled === true;
}

export function isVideoAppointment(row: { video_meeting_url?: string | null } | null | undefined): boolean {
  return Boolean(row?.video_meeting_url?.trim());
}

export function videoMeetingLine(url: string | null | undefined, locale: 'da' | 'en'): string {
  const trimmed = url?.trim() ?? '';
  if (!trimmed) return '';
  return locale === 'en' ? `Video meeting: ${trimmed}` : `Videomøde: ${trimmed}`;
}

export function pickVideoService<T extends { name: string; duration_minutes?: number | null }>(
  services: readonly T[],
): T | null {
  const match = services.find((service) =>
    service.name.toLowerCase().includes('videokonsultation'),
  );
  return match ?? null;
}

export function openExternalMeeting(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}
